import { useEffect } from "react";
import { i18n, useGetTermsAndConditionsForOffer } from "src/common";
import { ContainerComponent, Text, Flex, LoaderSquare } from "src/components";
import TermsCard from "src/components/cards/termsCard";
import { colors } from "src/theme";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export const TermsPage = () => {
  const { id } = useParams<{ id: string }>();
  const { termsAndConditions, loading, refetch } = useGetTermsAndConditionsForOffer(id);

  useEffect(() => {
    refetch();
  }, [])
  return (
    <ContainerComponent>
      <Helmet>
        <title>Uvijeti osiguranja | Osiguranje imovine - kompare.hr</title>
      </Helmet>
      {loading ? (
        <Flex justify="center" align="center">
          <LoaderSquare />
        </Flex>
      ) : !termsAndConditions || termsAndConditions.documents.length === 0 ? (
        <Text type="base" color={colors.text3} style={{ paddingTop: 40 }}>
          {i18n.t('pages.termsAndConditionsPage.noDocuments')}
        </Text>
      ) : (
        <Flex vertical gap={24} style={{ paddingTop: 40 }}>
          <Text type="xLarge" bold>
            {i18n.t('pages.termsAndConditionsPage.title')}
          </Text>
          <TermsCard termsAndConditions={termsAndConditions} isModal={false} />
        </Flex>
      )}
    </ContainerComponent>
  );
};